import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { withTranslation } from "react-i18next";
function Challenge({ item, t }) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {t('Challenge')} ({typeof item?.payload?.description === 'object' ? item?.payload?.description.old : item?.payload?.description}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        by
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {typeof item?.payload?.description === 'object' &&
            item?.payload?.description?.old &&
            item?.payload?.description?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Description')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.description?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.description?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.supportNeeded === "object" && 
           item?.payload?.supportNeeded?.old && item?.payload?.supportNeeded?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Support Needed')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.supportNeeded?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.supportNeeded?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.responsible === "object" && item?.payload?.responsible?.old && item?.payload?.responsible?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Responsible')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.responsible?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.responsible?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.supportDate &&
            item?.payload?.supportDate?.old >= 0 &&
            item?.payload?.supportDate?.new >= 0 && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Support Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {item?.payload?.supportDate?.old}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {item?.payload?.supportDate?.new}
                    </span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Challenge);